import { Component, Input } from '@angular/core';

import { CarrouselComponent } from '@ecm/carrousel';

@Component({
    selector: 'ecm-layout-container',
    templateUrl: './layout-container.component.html',
    standalone: true,
    imports: [CarrouselComponent],
})
export class LayoutContainerComponent {
    @Input() public lateralMenu = false;
    @Input() public carrousel = false;
    @Input() public isXlScreen = false;
}
